import {Injectable} from "@angular/core";
import { Route, Router, UrlSegment, UrlTree } from "@angular/router";
import {from, Observable} from "rxjs";
import {BaseComponent} from "../base.component";
import {LoggerService} from "../common/logger.service";
import {UserService} from "../common/user.service";
import {Constants} from "../constants";

@Injectable({
    providedIn: 'root',
})
export class NewCheckoutGuard extends BaseComponent  {
    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private router: Router
    ) {
        super(userService, loggerService);
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return from(this.getCustomerData().then(() => this.useNewCheckout || this.router.createUrlTree([Constants.CART_OVERVIEW_STATE])));
    }

}
